module.exports = __webpack_public_path__ + "static/media/fb.7526bd02.svg";